import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppConfig } from '../../app.config';
import { DatastoreService } from '../../services/datastore.service';
import { DobValidatorService } from '../../services/dob-validator.service';
import { ApiService } from '../../services/jrni/api.service';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { BasketService } from '../../services/jrni/basket.service';
import { DepartmentService } from '../../services/jrni/department.service';
import { MemberService } from '../../services/jrni/member.service';
import { ServicesService } from '../../services/jrni/services.service';
import { AlertService } from '../../_alert';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { AmazonService } from '../../services/jrni/amazon.service';
import { FormBuilderService } from '../../services/form-builder.service';
import { MatDialog } from '@angular/material/dialog';
import { LoginPopupComponent } from '../../components/login-popup-modal/login-popup/login-popup.component';
import { AddressLookupStatusComponent } from '@bookinglab/hwrc-ui';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-booking-details',
  templateUrl: './booking-details.component.html',
  styleUrls: ['./booking-details.component.scss'],
})
export class BookingDetailsComponent implements OnInit {
  parentDepartment;
  selectedDepartment;
  selectedService;
  pageTitle: string;
  dataPolicy: string;
  dataPolicyThree: string;
  declaration_question_override: string;
  bookingDetailsPageText: string;
  bookingQuestions = [];
  submitted: boolean;
  selectedLocation;
  requiresFullRegistration = false;
  organisationQuestions = [];
  today = new Date();
  selectedFile: string;
  subtmitButtonDisabled: boolean;
  bookingQuestionsConfig = AppConfig.settings.bookingQuestions;
  public dvlaLookupQuestionMap = AppConfig.settings.dvlaLookupQuestionMap;
  vehicleStatus: any = 0;
  addresses = [];
  addressFoundBefore = false;
  member;
  slot;
  banned = false;
  customerQuestions;
  unavailableTimes = [];
  // https://regexr.com/3pp3r <- Postcode validator
  postcodeValidator =
    '^(([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))s?[0-9][A-Za-z]{2}))$';
  showingAddresses = false;
  faChevronRight = faChevronRight;
  faChevronLeft = faChevronLeft;
  selectedAddressId;
  custodian_codes = [5390, 5600, 5660, 5960, 5990];
  isInLocalArea: boolean = true;
  showWasteWarning: boolean = false;
  wasteLimit: any = {};
  wasteUnits: string = 'litres';
  permitQuestion = AppConfig.settings.permitQuestion.toString();
  visibleContactQuestions: string;
  bookingQuestionsForm: UntypedFormGroup;
  registrationUsed: boolean;
  myVehicles: any = [];
  myAddresses: any = [];
  maxChildren: number = 1


  constructor(
    private router: Router,
    private servicesService: ServicesService,
    private departmentService: DepartmentService,
    private formBuilder: UntypedFormBuilder,
    private formService: FormBuilderService,
    private basketservice: BasketService,
    private alertService: AlertService,
    private translateService: TranslateService,
    private memberService: MemberService,
    public datastoreService: DatastoreService,
    private spinner: NgxSpinnerService,
    private apiService: ApiService,
    private amazonService: AmazonService,
    public addressLookupStatusComponent: AddressLookupStatusComponent,
    private dialog: MatDialog,
    private availabilityService: AvailabilityService
  ) { }

  // Initialise the customer form
  customerDetailsForm: UntypedFormGroup = new UntypedFormGroup(
    {
      first_name: new UntypedFormControl('', Validators.required),
      last_name: new UntypedFormControl('', Validators.required),
      // have_email: new UntypedFormControl('', Validators.required),
      email_address: new UntypedFormControl('', [
        Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i),
      ]),
      // confirm_email: new UntypedFormControl('', [
      //   Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i),
      // ]),
      // postcode: new FormControl("", [Validators.required, Validators.pattern(this.postcodeValidator)]),
      mobile_number: new UntypedFormControl(''),
      site_rules: new UntypedFormControl(false, Validators.requiredTrue),
      privacy_notice: new UntypedFormControl(false, Validators.requiredTrue),
    },
    {
      validators: this.emailOrMobileValidator(
        'email_address',
        "mobile_number"
      ),
    }
  );

  addressEnabled = AppConfig.settings.addressApi.enabled;

  emailOrMobileValidator(
    emailKey: string,
    // confirmEmailKey: string,
    mobileNumberKey: string
  ): ValidatorFn {
    return (group: UntypedFormGroup): { [key: string]: any } => {
      let email = group.controls[emailKey];
      // let confirmEmail = group.controls[confirmEmailKey];
      let mobileNumber = group.controls[mobileNumberKey];
      let returnValue = null
      mobileNumber.setErrors(null);
      // If the email and confirm email inputs have data
      // if (email.value.length > 0 && confirmEmail.value.length > 0) {
      //   // Check if the emails match
      //   if (email.value.toLowerCase() !== confirmEmail.value.toLowerCase()) {
      //     confirmEmail.setErrors({ mismatch: true });
      //     returnValue = {
      //       mismatch: true,
      //     };
      //   } else if (confirmEmail.errors && confirmEmail.errors.mismatch) {
      //     // If the errors object does not contain any other errors then set errors {} to null
      //     if (Object.keys(confirmEmail.errors).length == 1) {
      //       confirmEmail.setErrors(null);
      //     } else {
      //       // Delete the mismatch error from the object as we do not want to remove any other errors that exist in the {}
      //       delete confirmEmail.errors.mismatch;
      //     }
      //   } else {
      //     confirmEmail.setErrors(null);
      //     returnValue = null;
      //   }
      // }

      if (email.value.length > 0 || mobileNumber.value.length > 0) {
        if (mobileNumber.value) {
          if (mobileNumber.value.length !== 11) {
            mobileNumber.setErrors({ minlength: true });
            if (returnValue === null) {
              returnValue = { minlength: true };
            }
          }
        }
      } else {
        if (returnValue === null) {
          returnValue = { oneMustBeTrue: true };
        }
        mobileNumber.setErrors({ oneMustBeTrue: true });
      }
      return returnValue;
    }
  }

  // Getter for easy access to form fields
  get form() {
    return this.customerDetailsForm.controls;
  }
  get bookingForm() {
    return this.bookingQuestionsForm.controls;
  }

  routerGoBack() {
    this.router.navigate(['/calendar']);
  }

  restartJourney() {
    this.router.navigate(['/login']);
  }

  routerGoBackToServices() {
    this.router.navigate(['/services']);
  }

  localAddress() {
    const e = this.customerDetailsForm.controls.selectedAddress.value.address;
    const matchingCodes = this.custodian_codes.filter((code) => {
      if (e.LOCAL_CUSTODIAN_CODE === code) {
        return true;
      }
    });
    if (matchingCodes.length > 0) return true;
    else return false;
  }

  checkAddress(addr: any) {
    const matchingCodes = this.custodian_codes.filter((code) => {
      if (addr.LOCAL_CUSTODIAN_CODE === code) {
        return true;
      }
    });
    if (matchingCodes.length > 0) return true;
    else return false;
  }

  async getVehicle() {
    this.spinner.show();
    console.log(this.bookingQuestionsForm);
    console.log(this.dvlaLookupQuestionMap.regQuestionId);
    console.log(this.bookingQuestionsForm.controls[
      this.dvlaLookupQuestionMap.regQuestionId
    ]);
    this.registrationUsed = false
    let vehiclereg: string =
      this.bookingQuestionsForm.controls[
        this.dvlaLookupQuestionMap.regQuestionId
      ].value;
    this.datastoreService.registration = vehiclereg
      .toLowerCase()
      .replace(/\s/g, '');
    try {


      if (!this.datastoreService.permitData && this.selectedService.extra.permit_check_on_vehicle_reg === "Yes") {
        const companyName = AppConfig.settings.apiServer.api_url
          .split('//')[1]
          .split('.council')[0];
        const reg: any = await this.amazonService.checkPermitApplicationOperation(
          this.parentDepartment.id,
          companyName,
          "",
          'checkDetail',
          "",
          "",
          "",
          "vehicle_registration",
          "",
          "",
          vehiclereg
        );
        if (reg.found) {
          this.registrationUsed = true
          this.spinner.hide()
          return
        }
      }

      const vehicleLookup: any = await this.apiService.getVehicleDetails(
        vehiclereg
      );

      if (vehicleLookup.error) {
        let indexOfErrorCode = vehicleLookup.message.indexOf(
          ' ',
          vehicleLookup.message.indexOf(':') + 1
        ); // get first : from the error string

        let statusCodeErrorMessage = vehicleLookup.message.substring(
          indexOfErrorCode + 1,
          indexOfErrorCode + 4
        );

        if (statusCodeErrorMessage == '404') {
          this.vehicleStatus = 2;
        } else {
          this.vehicleStatus = 3;
        }
      } else {
        this.bookingQuestionsForm.controls[
          this.dvlaLookupQuestionMap.makeQuestionId
        ].setValue(vehicleLookup['result'].make);
        this.bookingQuestionsForm.controls[
          this.dvlaLookupQuestionMap.makeQuestionId
        ].patchValue(vehicleLookup['result'].make);

        this.bookingQuestionsForm.controls[
          this.dvlaLookupQuestionMap.colourQuestionId
        ].setValue(vehicleLookup['result'].colour);
        this.bookingQuestionsForm.controls[
          this.dvlaLookupQuestionMap.colourQuestionId
        ].patchValue(vehicleLookup['result'].colour);

        this.vehicleStatus = 1;
      }

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.log(error);
    }
  }

  async getAddress(repopulate: boolean = null) {
    try {

      this.showingAddresses = false;

      // Clear the addresses array
      this.addresses.length = 0;
      if (!repopulate)
        this.customerDetailsForm.controls.selectedAddress.setValue('');

      // Custom error handling for postcode
      let postcode: String = this.customerDetailsForm.value.postcode.replace(/\s/g, '');
      this.customerDetailsForm.controls.postcode.setValue(postcode);
      if (this.customerDetailsForm.controls.postcode.status == 'INVALID') {
        this.customerDetailsForm.get('postcode').setErrors({
          invalidPostcode: this.translateService.instant(
            'COMMON.INVALID_POSTCODE'
          ),
        });
        return;
      }
      this.spinner.show();
      const res = await this.amazonService.osGetNameDataEncodedApi(
        this.customerDetailsForm.value.postcode
      );
      if (
        this.customerDetailsForm.controls.postcode.errors &&
        this.customerDetailsForm.controls.postcode.errors.invalidPostcode
      ) {
        delete this.customerDetailsForm.controls.postcode.errors.invalidPostcode;
      }
      var object: any = res;
      if (object.results) {
        if (
          this.customerDetailsForm.controls.postcode.errors &&
          this.customerDetailsForm.controls.postcode.errors.addressNotFound
        ) {
          delete this.customerDetailsForm.controls.postcode.errors
            .addressNotFound;
        }
        var addresses = object.results;

        const addressesExist = addresses.filter((e) => {
          if (e.DPA) {
            return true;
          } else if (e.LPI) {
            return true;
          }
        });

        const addressException = await this.apiService.getAddressException();
        let expections = [];

        if (addressException) {
          expections = addressException['Items'];
        }

        let added = [];
        console.log(addressesExist);
        if (addressesExist.length > 1) {
          // If it matches up, push the addresses
          let localCodes = [];
          addressesExist.forEach((item) => {
            const expectionAddress = expections.find(({ UPRN }) => {
              if (item.DPA) {
                if (UPRN === item.DPA.UPRN) {
                  return true;
                }
              }
              if (item.LPI) {
                if (UPRN === item.LPI.UPRN) {
                  return true;
                }
              }

              return false;
            });

            const addedAlready = added.find(({ ADDRESS }) => {
              if (item.DPA) {
                if (ADDRESS === item.DPA.ADDRESS) {
                  return true;
                }
              }
              if (item.LPI) {
                if (ADDRESS === item.LPI.ADDRESS) {
                  return true;
                }
              }

              return false;
            });

            let alreadyEntered = false;

            if (expectionAddress === undefined) {
              alreadyEntered = this.addresses.some((e) => {
                if (item.DPA && item.DPA.UPRN === e.address.UPRN) {
                  return true;
                } else if (item.LPI && item.LPI.UPRN === e.address.UPRN) {
                  return true;
                }
              });
            }

            if (!alreadyEntered && addedAlready === undefined) {
              if (item.DPA) {
                const inLocalArea = this.checkAddress(item.DPA);
                this.addresses.push({ address: item.DPA });
                added.push({ ADDRESS: item.DPA.ADDRESS });
                if (inLocalArea) {
                  localCodes.push(inLocalArea);
                }
              } else {
                const inLocalArea = this.checkAddress(item.LPI);
                this.addresses.push({ address: item.LPI });
                added.push({ ADDRESS: item.LPI.ADDRESS });
                if (inLocalArea) {
                  localCodes.push(inLocalArea);
                }
              }
            }
          });

          if (repopulate) {
            let selectedAddress =
              this.customerDetailsForm.controls.selectedAddress.value.address.ADDRESS;
            for (let i = 0; i < this.addresses.length; i++) {
              let item = this.addresses[i];
              if (selectedAddress == item.address.ADDRESS) {
                this.selectedAddressId = i;
                this.customerDetailsForm.controls[
                  'selectedAddress'
                ].setValue(item);
              }
            }
          }

          if (localCodes.length > 0) {
            this.addresses = this.addresses.filter(
              (x) =>
                x.address.CLASSIFICATION_CODE[0] === 'R' ||
                x.address.CLASSIFICATION_CODE[0] === 'P' ||
                x.address.CLASSIFICATION_CODE[0] === 'PP' ||
                x.address.CLASSIFICATION_CODE[0] === 'C'
            );
            if (this.addresses.length === 0) {
              this.customerDetailsForm.get('postcode').setErrors({
                addressNotFound: this.translateService.instant(
                  'COMMON.ADDRESS_NOT_FOUND_RES'
                ),
              });
              this.spinner.hide();
            } else {
              this.showingAddresses = true;
              this.isInLocalArea = true;
            }
          } else {
            this.showingAddresses = true;
            this.isInLocalArea = false;
          }
        } else {
          // If it doesn't match up, show an error message
          console.log('dsd', addressesExist);
          this.customerDetailsForm.get('postcode').setErrors({
            invalidPostcode: this.translateService.instant(
              'COMMON.ADDRESS_NOT_ELIGIBLE'
            ),
          });
        }
      } else {
        this.customerDetailsForm.get('postcode').setErrors({
          addressNotFound: this.translateService.instant(
            'COMMON.ADDRESS_NOT_FOUND'
          ),
        });
      }
      this.spinner.hide();
    } catch (error) {
      console.log(error);
      await this.addressLookupStatusComponent.checkAddressLookupStatus(AppConfig, environment, this.datastoreService.config)
      this.spinner.hide();
    }
  }

  async checkVisitorAlertsTable(registration) {
    this.datastoreService.banned = false;
    this.datastoreService.observe = false;

    const res: any = await this.apiService.getAlertTableStatus(
      registration.replace(/\s/g, '').toUpperCase()
    );
    console.log(res);
    if (res) {
      console.log(res.hasOwnProperty('found'), res.found);
      if (res.hasOwnProperty('found')) {
        for (let find of res.found) {
          console.log(find);
          console.log(find.status === 'BANNED');
          if (find.status === 'BANNED') {
            this.datastoreService.banned = true;
          }
          if (find.status === 'OBSERVE') {
            this.datastoreService.observe = true;
          }
        }
      }
    }
  }

  async bannedRegistrationCheck(registration) {
    // Banned vehicle registrations from API
    // if (this.parentDepartment.extra.banned_vehicle_registration_numbers) {
    // If there are any banned vehicle registration numbers, run the check
    // var str = this.parentDepartment.extra.banned_vehicle_registration_numbers.replace(/\s/g, '').toLowerCase();
    // var banned = new Array();
    // banned = str.split(",");
    var banned: any = await this.apiService.getBanned();
    // Value to return
    // Check for match between banned registrations and users registration
    console.log(banned);
    if (banned.registrations) {
      for (let item of banned.registrations) {
        if (item.regno) {
          if (
            item.regno.replace(/\s/g, '').toLowerCase() ==
            registration.replace(/\s/g, '').toLowerCase()
          ) {
            return true;
          }
        } else {
          if (
            item.replace(/\s/g, '').toLowerCase() ==
            registration.replace(/\s/g, '').toLowerCase()
          ) {
            return true;
          }
        }
      }
      return false;
    } else {
      return false;
    }
  }

  formatPostcode() { }

  ngOnInit() {
    // Initialise the form
    this.bookingQuestionsForm = this.formBuilder.group({});

    this.scrollToTop();

    if (this.addressEnabled) {
      this.customerDetailsForm.addControl(
        'postcode',
        new UntypedFormControl('', [
          Validators.required,
          Validators.pattern(this.postcodeValidator),
        ])
      );
      this.customerDetailsForm.addControl(
        'selectedAddress',
        new UntypedFormControl('', Validators.required)
      );
    }

    this.availabilityService.getSelectedSlot().then((slot) => {
      if (slot) {
        this.slot = slot;
      }
    });

    this.parentDepartment = this.datastoreService.parentDepartment;

    if (this.parentDepartment) {
      this.spinner.show();
      this.selectedDepartment = this.datastoreService.selectedDepartment;
      let registrationOption = '';
      let organisationQuestionsID;

      // Set the title on the login page to the title from the business question
      this.parentDepartment.extra?.hasOwnProperty('booking_details_page_title')
        ? (this.pageTitle =
          this.parentDepartment.extra.booking_details_page_title)
        : (this.pageTitle = 'Booking details title not set');

      // Get the configurable data
      if (this.parentDepartment.hasOwnProperty('extra')) {
        // Set the extra text on the page to the text taken from the business question

        this.parentDepartment.extra.hasOwnProperty(
          'declaration_question_override'
        )
          ? (this.declaration_question_override =
            this.parentDepartment.extra.declaration_question_override)
          : (this.declaration_question_override =
            'declaration question not set');

        this.parentDepartment.extra.hasOwnProperty('booking_details_page_text')
          ? (this.bookingDetailsPageText =
            this.parentDepartment.extra.booking_details_page_text)
          : null;

        // Set the extra text on the page to the text taken from the business question
        this.parentDepartment.extra.hasOwnProperty('booking_details_page_text')
          ? (this.bookingDetailsPageText =
            this.parentDepartment.extra.booking_details_page_text)
          : null;
        // Get the registration option
        this.parentDepartment.extra.hasOwnProperty('registration_option')
          ? (registrationOption =
            this.parentDepartment.extra.registration_option)
          : null;
        // Get the organistion customer questions
        this.parentDepartment.extra.hasOwnProperty('organisations_questions')
          ? (organisationQuestionsID =
            this.parentDepartment.extra.organisations_questions)
          : null;

        // If the register option is set to complete a full registration then capture the following details
        if (registrationOption.toLowerCase() === 'register complete details') {
          this.requiresFullRegistration = true;
        }
      }

      //     // Use this.departmentService.getLocation() if the services are set on the children departments
      //     // Use this.departmentService.get() if the services are set on the parent department
      this.departmentService.get().then(async (location) => {
        this.selectedLocation = location;

        // Delete any exisitng baskets to avoid conflicts
        if (this.basketservice.currentBasket) {
          // await this.basketservice.delete(
          //   this.selectedLocation,
          //   this.basketservice.currentBasket
          // );
        }
        // Create the basket
        // this.basketservice.createBasket(location).then(
        //   (basket) => {
        //     this.basketservice.currentBasket = basket;

        this.memberService.getMember().then((member) => {
          this.member = member;

          // Get the customer questions
          this.departmentService
            .getCustomerQuestions()
            .then((questions) => {
              this.customerQuestions = questions;
              this.datastoreService.customerQuestions = questions;
              for (
                let index = 0;
                index < this.customerQuestions.length;
                index++
              ) {
                const question = this.customerQuestions[index];
                question.visible = false;
                question.reference = question.id;
                if (!question.admin_only) {
                  if (
                    !question.settings.hasOwnProperty(
                      'conditional_question'
                    )
                  ) {
                    question.visible = true;
                  }

                  const questionControl = question.id;
                  if (
                    question.detail_type == 'check' ||
                    question.detail_type == 'check-price'
                  ) {
                    if (question.default == 1) {
                      if (question.required) {
                        this.customerDetailsForm.addControl(
                          questionControl,
                          new UntypedFormControl(true, Validators.required)
                        );
                      } else {
                        this.customerDetailsForm.addControl(
                          questionControl,
                          new UntypedFormControl(true)
                        );
                      }
                    } else {
                      if (question.required) {
                        this.customerDetailsForm.addControl(
                          questionControl,
                          new UntypedFormControl(false, Validators.required)
                        );
                      } else {
                        this.customerDetailsForm.addControl(
                          questionControl,
                          new UntypedFormControl(false)
                        );
                      }
                    }
                  } else {
                    if (questionControl === 382) {
                      // postcode custom question needs validation
                      // if (!this.addressEnabled) {  // postcode custom question not needed if we are doing address lookup
                      //   if (question.required) {
                      //     this.customerDetailsForm.addControl(questionControl, new FormControl('', [Validators.required, Validators.pattern(this.postcodeValidator)]));
                      //   } else {
                      //     this.customerDetailsForm.addControl(questionControl, new FormControl('', Validators.pattern(this.postcodeValidator)));
                      //   }
                      //   this.customerDetailsForm.get("382").valueChanges.subscribe(value => { //force uppercase and space removal
                      //     if (value !== value.replace(/\s/g, "").toUpperCase().slice(0, 8)) {
                      //       this.customerDetailsForm.controls["382"].setValue(value.replace(/\s/g, "").toUpperCase().slice(0, 8));
                      //     }
                      //   });
                      // }
                    } else {
                      if (question.required) {
                        this.customerDetailsForm.addControl(
                          questionControl,
                          new UntypedFormControl('', Validators.required)
                        );
                      } else {
                        this.customerDetailsForm.addControl(
                          questionControl,
                          new UntypedFormControl('')
                        );
                      }
                    }
                  }
                }
              }

              // });

              //     // Get the selected service
              this.servicesService.get().then((service) => {
                this.selectedService = service;
                console.log(this.selectedService);
                //privacy notice from config if exists
                if (this.selectedService.extra.hasOwnProperty('privacy_notice') || this.datastoreService.config?.userJourney?.privacyNotice) {
                  if (this.datastoreService.config?.userJourney?.privacyNotice) {
                    this.dataPolicy = this.datastoreService.config?.userJourney?.privacyNotice;
                  }
                  else {
                    this.dataPolicy = this.selectedService.extra.privacy_notice;
                  }
                }
                else {
                  this.dataPolicy = 'privacy notice not set';
                }
                //terms and conditions from config if exists
                if (this.selectedService.extra.hasOwnProperty('siteRules') || this.datastoreService.config?.userJourney?.siteRules) {
                  if (this.datastoreService.config?.userJourney?.siteRules) {
                    this.dataPolicyThree = this.datastoreService.config?.userJourney?.siteRules;
                  }
                  else {
                    this.dataPolicyThree = this.selectedService.extra.siteRules;
                  }
                }
                else {
                  this.dataPolicyThree = 'site rules not set';
                }
                // Get the questions
                this.selectedService.$get('questions').then(async (res) => {
                  let bookingQuestions = [];
                  for (const q of res.questions) {
                    if (this.selectedLocation.id === 37005) {
                      if (q.id !== 10 && q.id.toString() !== this.permitQuestion) {
                        bookingQuestions.push(q);
                      }
                    } else {
                      bookingQuestions.push(q);
                    }
                  }
                  this.bookingQuestions = bookingQuestions;
                  this.datastoreService.bookingQuestions = this.bookingQuestions;

                  for (let index = 0; index < bookingQuestions.length; index++) {
                    const question = bookingQuestions[index];
                    question.visible = false;
                    question.reference = question.id;
                    if (!question.admin_only) {
                      if (!question.settings.hasOwnProperty('conditional_question')) {
                        question.visible = true;
                      }
                      const questionControl = question.id;

                      if (
                        question.detail_type == 'check' ||
                        question.detail_type == 'check-price'
                      ) {
                        if (question.required) {
                          this.bookingQuestionsForm.addControl(
                            questionControl,
                            new UntypedFormControl(false, Validators.requiredTrue)
                          );
                        } else {
                          this.bookingQuestionsForm.addControl(
                            questionControl,
                            new UntypedFormControl(false)
                          );
                        }
                      } else {
                        if (question.required) {
                          this.bookingQuestionsForm.addControl(
                            questionControl,
                            new UntypedFormControl('', Validators.required)
                          );
                        } else {
                          this.bookingQuestionsForm.addControl(
                            questionControl,
                            new UntypedFormControl('')
                          );
                        }
                      }
                    }
                  }

                  if (this.selectedService.permitQuestion) {
                    // this.bookingQuestionsForm.controls[
                    //   AppConfig.settings.vehicleHireQuestion
                    // ].setValue(this.selectedService.permitQuestion.hire);
                    // this.bookingQuestionsForm.controls[
                    //   AppConfig.settings.vehicleHireQuestion
                    // ].disable();
                    if (this.selectedService.vehicleRegQuestion.answer) {
                      this.bookingQuestionsForm.controls[
                        this.selectedService.vehicleRegQuestion.id
                      ].setValue(this.selectedService.vehicleRegQuestion.answer);
                      console.log(
                        this.bookingQuestionsForm.controls[
                        this.selectedService.vehicleRegQuestion.id
                        ]
                      );
                      this.bookingQuestionsForm.controls[
                        this.selectedService.vehicleRegQuestion.id
                      ].disable();
                      await this.getVehicle();
                      // if (this.selectedService.vehicleRegQuestion.vehicle_model) {
                      //   this.bookingQuestionsForm.controls[
                      //     AppConfig.settings.vehicleModelQuestion
                      //   ].setValue(
                      //     this.selectedService.vehicleRegQuestion.vehicle_model
                      //   );
                      //   this.bookingQuestionsForm.controls[
                      //     AppConfig.settings.vehicleModelQuestion
                      //   ].disable();
                      // }
                    } else {
                      this.bookingQuestionsForm.controls[
                        this.selectedService.vehicleRegQuestion.id
                      ].disable();
                      this.bookingQuestions.find(
                        (x) => x.id === this.selectedService.vehicleRegQuestion.id
                      ).permanentlyHidden = true;
                      this.bookingQuestions.find(
                        (x) => x.id === this.dvlaLookupQuestionMap.colourQuestionId
                      ).permanentlyHidden = true;
                      this.bookingQuestions.find(
                        (x) => x.id === this.dvlaLookupQuestionMap.makeQuestionId
                      ).permanentlyHidden = true;
                      // this.bookingQuestionsForm.controls[
                      //   AppConfig.settings.vehicleModelQuestion
                      // ].disable();
                      // this.bookingQuestions.find(
                      //   (x) => x.id === AppConfig.settings.vehicleModelQuestion
                      // ).permanentlyHidden = true;
                      this.vehicleStatus = 1;
                    }
                  }
                  // if (this.bookingQuestionsForm.controls[
                  //   this.dvlaLookupQuestionMap.colourQuestionId
                  // ]) {
                  //   this.bookingQuestionsForm.controls[
                  //     this.dvlaLookupQuestionMap.colourQuestionId
                  //   ].disable();
                  // }
                  // if (this.bookingQuestionsForm.controls[
                  //   this.dvlaLookupQuestionMap.makeQuestionId
                  // ]) {
                  //   this.bookingQuestionsForm.controls[
                  //     this.dvlaLookupQuestionMap.makeQuestionId
                  //   ].disable();
                  // }
                  // Repopulate the booking questions when coming back
                  this.datastoreService.bookingForm ? this.repopulateQuestions() : null;
                  let member = await this.memberService.getMember()
                  this.member = member;
                  if (this.member) {
                    this.spinner.show();

                    console.log("member", this.member)
                    // this.customerDetailsForm.controls['have_email'].setValue('Yes')
                    // this.onHaveEmailChange()
                    // this.customerDetailsForm.controls['have_email'].disable()

                    this.customerDetailsForm.controls['first_name'].setValue(this.member.first_name)
                    this.customerDetailsForm.controls['last_name'].setValue(this.member.last_name)
                    this.customerDetailsForm.controls['email_address'].setValue(this.member.email)
                    // this.customerDetailsForm.controls['confirm_email'].setValue(this.member.email)
                    this.customerDetailsForm.controls['first_name'].disable()
                    this.customerDetailsForm.controls['last_name'].disable()
                    this.customerDetailsForm.controls['email_address'].disable()
                    // this.customerDetailsForm.controls['confirm_email'].disable()

                    this.myAddresses = []
                    this.myVehicles = []
                    console.log(this.member, this.customerDetailsForm)
                    // this.populateFromMember(this.member)
                    for (let i = 1; i <= this.maxChildren; i++) {
                      const address: any = await this.apiService.getHwrcAddressForm(member.id, this.parentDepartment.id, i)
                      if (address.hasOwnProperty('Item')) {
                        this.myAddresses.push(address.Item)
                      }
                      const vehicle: any = await this.apiService.getHwrcVehicleForm(member.id, this.parentDepartment.id, i)
                      if (vehicle.hasOwnProperty('Item')) {
                        this.myVehicles.push(vehicle.Item)
                      }
                    }
                    console.log("my advs", this.myAddresses, this.myVehicles)
                    console.log(" this.bookingQuestionsForm", this.bookingQuestionsForm)
                    if (this.myAddresses.length === 1) {
                      this.customerDetailsForm.controls['selectedAddress'].setValue(this.myAddresses[0].address)
                      this.customerDetailsForm.controls['selectedAddress'].patchValue(this.myAddresses[0].address)
                      this.bookingQuestionsForm.value['selectedAddress'] = this.myAddresses[0].address
                      this.customerDetailsForm.controls['postcode'].setValue(this.myAddresses[0].postcode)
                      this.customerDetailsForm.controls['postcode'].patchValue(this.myAddresses[0].postcode)
                      this.bookingQuestionsForm.value['postcode'] = this.myAddresses[0].postcode
                      this.customerDetailsForm.controls['selectedAddress'].disable()
                    }
                    if (this.myVehicles.length === 1) {
                      this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.regQuestionId].setValue(this.myVehicles[0].vehicle_registration)
                      this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.regQuestionId].patchValue(this.myVehicles[0].vehicle_registration)
                      this.bookingQuestionsForm.value[this.dvlaLookupQuestionMap.regQuestionId] = this.myVehicles[0].vehicle_registration
                      this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.regQuestionId].disable()
                      await this.populateStoredVehicleDetails()
                    }
                  }
                  await this.addressLookupStatusComponent.checkAddressLookupStatus(AppConfig, environment, this.datastoreService.config)
                  this.spinner.hide();
                });
              });
            });
        });
      },
        (err) => {
          this.alertService.error(
            this.translateService.instant('COMMON.GENERAL_ERR')
          );
          this.spinner.hide();
        }
      );
    } else {
      this.restartJourney();
    }
  }

  populateFromMember(member) {
    this.customerDetailsForm.controls["first_name"].setValue(member.first_name);
    this.customerDetailsForm.controls["first_name"].patchValue(member.first_name);
    this.customerDetailsForm.controls["first_name"].disable()
    this.customerDetailsForm.controls["last_name"].setValue(member.last_name);
    this.customerDetailsForm.controls["last_name"].patchValue(member.last_name);
    this.customerDetailsForm.controls["last_name"].disable()
    this.customerDetailsForm.controls["email_address"].setValue(member.email);
    this.customerDetailsForm.controls["email_address"].patchValue(member.email);
    this.customerDetailsForm.controls["email_address"].disable()
  }


  async populateStoredVehicleDetails(skip = false) {
    let vehiclereg: String = this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.regQuestionId].value;
    let vehicle = this.myVehicles.find((x) => x.vehicle_registration === vehiclereg)
    // if (vehicle.vehicle_make && vehicle.vehicle_make !== "" && vehicle.vehicle_make !== "undefined") {
    // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.makeQuestionId].setValue(vehicle.vehicle_make);
    // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.makeQuestionId].patchValue(vehicle.vehicle_make);
    // // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.makeQuestionId].disable()

    // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.colourQuestionId].setValue(vehicle.vehicle_colour);
    // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.colourQuestionId].patchValue(vehicle.vehicle_colour);
    if (!skip) {
      this.onQuestionChange(true);
    }
    // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.colourQuestionId].disable()
    // } else {
    //   const vehicleLookup: any = await this.apiService.getVehicleDetails(vehiclereg);

    //   this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.makeQuestionId].setValue(vehicleLookup['result'].make);
    //   this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.makeQuestionId].patchValue(vehicleLookup['result'].make);
    // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.makeQuestionId].disable()

    // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.colourQuestionId].setValue(vehicleLookup['result'].colour);
    // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.colourQuestionId].patchValue(vehicleLookup['result'].colour);
    // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.colourQuestionId].disable()
    // }
    // this.vehicleStatus = 1;

    // this.datastoreService.vehicleStatus = this.vehicleStatus;
  }

  repopulateQuestions() {
    this.bookingQuestionsForm = this.datastoreService.bookingForm;
    this.customerDetailsForm = this.datastoreService.customerDetailsForm;
    this.vehicleStatus = 1;
    if (!this.datastoreService.showEmailAddress) {
      this.customerDetailsForm.controls['email_address'].setValue('')
      this.customerDetailsForm.value.email_address = ''
    }
    this.getAddress(true)
    this.onQuestionChange();
    // this.onHaveEmailChange();
  }

  async getPostcode() { // for when selecting from a client's prefilled list of addresses
    let address: String = this.customerDetailsForm.value['selectedAddress'];
    const selectedAddress = this.myAddresses.find((x) => x.address === address)
    // populate the postcode question
    this.customerDetailsForm.controls['postcode'].setValue(selectedAddress.postcode);
    this.customerDetailsForm.controls['postcode'].patchValue(selectedAddress.postcode);
    // check if it is local
    const res: any = await this.apiService.get(this.customerDetailsForm.value.postcode)
    const foundAddress = res.results.find((x) => {
      if (x.DPA) {
        return x.DPA.ADDRESS === address
      } else if (x.LPI) {
        return x.LPI.ADDRESS === address
      } else {
        return false
      }
    })
    if (foundAddress) {
      this.isInLocalArea = this.formService.localAddress(foundAddress)
    } else {
      console.log("error: could not find address address in ", res)
      this.isInLocalArea = false
    }
    console.log("this.idLocalAddress", this.isInLocalArea)
  }

  async onQuestionChange(skip = false) {
    const bookingQuestions = this.bookingQuestions;
    // Conditional questions logic
    for (let index = 0; index < bookingQuestions.length; index++) {
      const q = bookingQuestions[index];
      // If the question has settings and relies on a conditional question
      if (q.settings && q.settings.hasOwnProperty('conditional_question')) {
        // Get the conditional question based on the id set in q
        const conditionalQ = bookingQuestions.filter(
          (question) => question.id == q.settings.conditional_question
        );
        // Get the question control
        const questionControl =
          this.bookingForm[q.settings.conditional_question];
        // If the question control has a value get the option from the contional question. This will allow
        // us to check if q is shown when value is selected
        if (conditionalQ[0].hasOwnProperty('options')) {
          const option = conditionalQ[0].options.filter(
            (option) => option.name == questionControl.value
          );
          // If the conditional question is visible and the value chosen === to qs conditional answer then show q
          if (
            conditionalQ.length > 0 &&
            conditionalQ[0].visible &&
            option.length > 0 &&
            q.settings.conditional_answers.hasOwnProperty(option[0].id)
          ) {
            this.bookingForm[q.id].enable();
            // If the condiditonal question is important, Hide it
            if (q.important) {
              q.visible = false;
            } else {
              q.visible = true;
            }
          } else {
            q.visible = false;
            this.bookingForm[q.id].setValue('');
            this.bookingForm[q.id].disable();
          }
        } else {
          if (
            questionControl.value &&
            conditionalQ.length > 0 &&
            conditionalQ[0].visible
          ) {
            this.bookingForm[q.id].enable();
            if (q.important) {
              q.visible = false;
            } else {
              q.visible = true;
            }
          } else {
            q.visible = false;
            this.bookingForm[q.id].setValue('');
            this.bookingForm[q.id].disable();
          }
        }
      }
    }
    if (this.myVehicles.length === 1 && this.bookingQuestions.find((x) => x.id.toString() === this.dvlaLookupQuestionMap.regQuestionId.toString()).visible) {
      this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.regQuestionId].setValue(this.myVehicles[0].vehicle_registration)
      this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.regQuestionId].patchValue(this.myVehicles[0].vehicle_registration)
      this.bookingQuestionsForm.value[this.dvlaLookupQuestionMap.regQuestionId] = this.myVehicles[0].vehicle_registration
      this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.regQuestionId].disable()
      await this.populateStoredVehicleDetails(skip)
    }
    // if (this.bookingQuestionsForm.controls[
    //   this.dvlaLookupQuestionMap.colourQuestionId
    // ]) {
    //   this.bookingQuestionsForm.controls[
    //     this.dvlaLookupQuestionMap.colourQuestionId
    //   ].disable();
    // }
    // if (this.bookingQuestionsForm.controls[
    //   this.dvlaLookupQuestionMap.makeQuestionId
    // ]) {
    //   this.bookingQuestionsForm.controls[
    //     this.dvlaLookupQuestionMap.makeQuestionId
    //   ].disable();
    // }

  }

  // onHaveEmailChange() {
  //   if (this.customerDetailsForm.controls['have_email'].value === 'Yes') {
  //     this.customerDetailsForm.controls['email_address'].enable();
  //     this.customerDetailsForm.controls['confirm_email'].enable();
  //     this.customerDetailsForm.controls['mobile_number'].disable();
  //     this.customerDetailsForm.controls['mobile_number'].setValue('');
  //     this.visibleContactQuestions = 'email';
  //   } else if (this.customerDetailsForm.controls['have_email'].value === 'No') {
  //     this.customerDetailsForm.controls['mobile_number'].enable();
  //     this.customerDetailsForm.controls['email_address'].disable();
  //     this.customerDetailsForm.controls['email_address'].setValue('');
  //     this.customerDetailsForm.controls['confirm_email'].disable();
  //     this.customerDetailsForm.controls['confirm_email'].setValue('');
  //     this.visibleContactQuestions = 'phone';
  //   } else {
  //     this.visibleContactQuestions = '';
  //     this.customerDetailsForm.controls['mobile_number'].enable();
  //     this.customerDetailsForm.controls['email_address'].enable();
  //     this.customerDetailsForm.controls['confirm_email'].enable();
  //     this.customerDetailsForm.controls['mobile_number'].setValue('');
  //     this.customerDetailsForm.controls['email_address'].setValue('');
  //     this.customerDetailsForm.controls['confirm_email'].setValue('');
  //   }
  // }

  onMobileChange() {
    if (this.customerDetailsForm.controls['mobile_number'].value) {
      let stringMobile =
        this.customerDetailsForm.controls['mobile_number'].value.toString();
      if (stringMobile.length > 11) {
        // max 11
        // event.preventDefault()
        stringMobile = stringMobile.slice(0, 11);
        this.customerDetailsForm.controls['mobile_number'].setValue(
          parseInt(stringMobile)
        );
      }
    }
  }

  onFileChange(event, questionId) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.form[questionId].setValue(file, { emitModelToViewChange: false });
      this.bookingQuestionsForm.patchValue({
        fileSource: file,
      });
    }
  }

  async onSubmit() {
    this.spinner.show();
    this.submitted = true;
    this.alertService.clear();
    console.log(this.customerDetailsForm);
    console.log(this.bookingQuestionsForm);
    this.datastoreService.showEmailAddress = true;

    if (this.customerDetailsForm.controls['email_address'].valid || this.customerDetailsForm.controls['mobile_number'].valid) {
      // either email or mobile is filled in
      if (this.customerDetailsForm.controls['email_address'].errors) {
        delete this.customerDetailsForm.controls['email_address'].errors.required;
        if (JSON.stringify(this.customerDetailsForm.controls['email_address'].errors) === '{}') {
          this.customerDetailsForm.controls['email_address'].setErrors(null);
        }
      }

      if (this.customerDetailsForm.controls['mobile_number'].errors) {
        delete this.customerDetailsForm.controls['mobile_number'].errors.required;
        if (JSON.stringify(this.customerDetailsForm.controls['mobile_number'].errors) === '{}') {
          this.customerDetailsForm.controls['mobile_number'].setErrors(null);
        }
      }
    } else {
      this.scrollToTop();
      this.spinner.hide();
      this.alertService.warn(this.translateService.instant('FORM.VALIDATION_ERR_MSG'));
      return;
    }

    // If mobile number & no email address, create email address
    if (this.customerDetailsForm.value.mobile_number && !this.customerDetailsForm.value.email_address) {
      // Email address = [first name][last name][mobile number]@bookinglab.co.uk
      let generatedEmailAddress = `${this.customerDetailsForm.value.first_name}${this.customerDetailsForm.value.last_name}${this.customerDetailsForm.value.mobile_number}`;
      generatedEmailAddress = generatedEmailAddress.replace(/\s/g, '').toLowerCase() + '@bookinglab.co.uk';
      this.customerDetailsForm.value.email_address = generatedEmailAddress;
      this.customerDetailsForm.controls['email_address'].setValue(generatedEmailAddress);
      this.datastoreService.showEmailAddress = false;
      // To show the email address in the form UI uncomment below
      // this.customerDetailsForm.patchValue({email_address: generatedEmailAddress})
    }
    console.log(this.customerDetailsForm.invalid, this.bookingQuestionsForm.invalid);
    // Check if form is valid 
    if (this.customerDetailsForm.invalid || this.bookingQuestionsForm.invalid) {
      this.scrollToTop();
      this.spinner.hide();
      this.alertService.warn(
        this.translateService.instant('FORM.VALIDATION_ERR_MSG')
      );
      return;
    }

    const vehicleRegQuestion = this.bookingQuestions.find((x) => x.id.toString() === this.dvlaLookupQuestionMap.regQuestionId.toString())

    // if (
    //   vehicleRegQuestion && vehicleRegQuestion?.visible
    // ) {
    //   if (this.vehicleStatus !== 1 || this.registrationUsed) {
    //     this.scrollToTop();
    //     console.log("this.vehicleStatus", this.vehicleStatus)
    //     this.alertService.warn(
    //       this.translateService.instant('FORM.VALIDATION_ERR_MSG')
    //     );
    //     this.spinner.hide();
    //     return;
    //   }
    // } else {
    //   this.vehicleStatus === 0;
    //   this.datastoreService.registration = '';
    // }

    var currentDate = new Date(this.slot.datetime);

    // for some reason this function sometimes doesn't get run, adding the console logs fixed this (not sure why)
    console.log("this.customerDetailsForm", this.customerDetailsForm);
    await this.apiService
      .checkForDoubleBooking(
        this.selectedDepartment,
        currentDate,
        this.customerDetailsForm.controls.email_address.value
          ? this.customerDetailsForm.controls.email_address.value
          : null,
          this.customerDetailsForm.controls.mobile_number.value
          ? this.customerDetailsForm.controls.mobile_number.value
          : null,
      )
      .then((res: []) => {
        // res = array of unavailable times
        this.unavailableTimes = res;

        this.completeBooking();
      });
  }

  async completeBooking() {
    // now check restricetd waste
    for (const q of this.bookingQuestions) {
      const value = this.bookingQuestionsForm.value[q.id];
      if (q.id === 8) {
        this.datastoreService.isRestrictedBooking = value;
      }
      if (q.id === 11) {
        this.datastoreService.isRestrictedAsbestosBooking = value;
      }

      // Commercial wast check
      // if (q.id === 10) {
      //   this.datastoreService.isCommercialBooking = value;
      // }
    }
    if (this.addressLookupStatusComponent.getAddressLookupUnavailable()) {
      this.datastoreService.addressLookupUnavailable = true;
    } else{
      this.datastoreService.addressLookupUnavailable = false;
    }
    if (this.addressEnabled) {
      if (this.myAddresses.length === 0) {
        console.log("this.customerDetailsForm.controls.selectedAddress.value", this.customerDetailsForm.controls.selectedAddress.value)
        if (this.datastoreService.addressLookupUnavailable) {
          this.datastoreService.address1 = this.customerDetailsForm.controls.selectedAddress.value;
        } else {
          let selectedAddress;
          let addressFirstPart;
          if (!this.customerDetailsForm.controls.selectedAddress.value.address) {
            this.alertService.warn(
              this.translateService.instant('FORM.VALIDATION_ERR_MSG')
            );
            this.scrollToTop();
            this.spinner.hide();
            return;
          }


          if (this.customerDetailsForm.controls.selectedAddress.value.address) {
            selectedAddress =
              this.customerDetailsForm.controls.selectedAddress.value.address;
            if (selectedAddress.LPI_KEY) {
              // IF LPI
              if (selectedAddress.PAO_START_NUMBER) {
                addressFirstPart = `${selectedAddress.SAO_TEXT ? selectedAddress.SAO_TEXT : ''
                  } ${selectedAddress.PAO_START_NUMBER}`;
              } else if (selectedAddress.PAO_TEXT) {
                addressFirstPart = `${selectedAddress.SAO_TEXT ? selectedAddress.SAO_TEXT : ''
                  } ${selectedAddress.PAO_TEXT}`;
              }
            } else {
              // IF DPA
              if (
                this.customerDetailsForm.controls.selectedAddress.value.address
                  .BUILDING_NUMBER &&
                this.customerDetailsForm.controls.selectedAddress.value.address
                  .ORGANISATION_NAME
              ) {
                addressFirstPart = `${this.customerDetailsForm.controls.selectedAddress.value.address.ORGANISATION_NAME}, ${this.customerDetailsForm.controls.selectedAddress.value.address.BUILDING_NAME}, ${this.customerDetailsForm.controls.selectedAddress.value.address.BUILDING_NUMBER},`;
              } else {
                if (
                  this.customerDetailsForm.controls.selectedAddress.value.address
                    .BUILDING_NUMBER &&
                  this.customerDetailsForm.controls.selectedAddress.value.address
                    .ORGANISATION_NAME
                ) {
                  addressFirstPart = `${this.customerDetailsForm.controls.selectedAddress.value.address.BUILDING_NUMBER}, ${this.customerDetailsForm.controls.selectedAddress.value.address.ORGANISATION_NAME}`;
                } else if (
                  this.customerDetailsForm.controls.selectedAddress.value.address
                    .BUILDING_NAME &&
                  this.customerDetailsForm.controls.selectedAddress.value.address
                    .ORGANISATION_NAME
                ) {
                  addressFirstPart = `${this.customerDetailsForm.controls.selectedAddress.value.address.ORGANISATION_NAME}, ${this.customerDetailsForm.controls.selectedAddress.value.address.BUILDING_NAME}`;
                } else {
                  if (
                    this.customerDetailsForm.controls.selectedAddress.value.address
                      .BUILDING_NUMBER
                  ) {
                    addressFirstPart =
                      this.customerDetailsForm.controls.selectedAddress.value.address
                        .BUILDING_NUMBER;
                  } else if (
                    this.customerDetailsForm.controls.selectedAddress.value.address
                      .BUILDING_NAME
                  ) {
                    addressFirstPart =
                      this.customerDetailsForm.controls.selectedAddress.value.address
                        .BUILDING_NAME;
                  } else {
                    addressFirstPart =
                      this.customerDetailsForm.controls.selectedAddress.value.address
                        .ORGANISATION_NAME;
                  }
                }
              }
            }
          } else {
            this.alertService.warn(
              this.translateService.instant('FORM.VALIDATION_ERR_MSG')
            );
            this.scrollToTop();
            this.spinner.hide();
            this.customerDetailsForm.get('selectedAddress').setErrors({
              required: this.translateService.instant('COMMON.ADDRESS_NOT_FOUND'),
            });
            return;
          }




          // Fix issue where the thoroughfare name and street description are not available.
          let address1 = '';
          if (
            this.customerDetailsForm.controls.selectedAddress.value.address
              .THOROUGHFARE_NAME ||
            this.customerDetailsForm.controls.selectedAddress.value.address
              .STREET_DESCRIPTION
          ) {
            address1 = `${addressFirstPart.toLowerCase()} ${this.customerDetailsForm.controls.selectedAddress.value.address
              .THOROUGHFARE_NAME
              ? this.customerDetailsForm.controls.selectedAddress.value.address.THOROUGHFARE_NAME.toLowerCase()
              : this.customerDetailsForm.controls.selectedAddress.value.address.STREET_DESCRIPTION.toLowerCase()
              }`;
          } else {
            address1 = `${addressFirstPart.toLowerCase()} ${this.customerDetailsForm.controls.selectedAddress.value.address
              .DEPENDENT_LOCALITY
              }`;
          }
          this.datastoreService.address1 = selectedAddress.ADDRESS.toLowerCase();
        }
        // Check our API if the user has booked already in the past 7 days
        // If there is a weekly booking limit
      } else {
        this.datastoreService.address1 = this.customerDetailsForm.controls.selectedAddress.value.toLowerCase();
      }

      this.datastoreService.isInLocalArea = this.isInLocalArea
      let limitReached = false;

      let failHouse = false;
      let failVehicle = false;
      let limitMonth = 0;
      try {
        if (this.datastoreService.config?.hwrcBookingLimits?.enabled) {
          const slot: any = await this.availabilityService.getSelectedSlot();
          const slotDateTime = slot.datetime;
          const selectedService = await this.servicesService.get();
          const bookingLimitDataHouse: any =
            await this.apiService.checkBookingLimit(
              this.datastoreService.parentDepartment,
              this.datastoreService.address1,
              slotDateTime,
              selectedService
            );
          limitMonth = bookingLimitDataHouse.limits.monthlyLimit;
          if (!bookingLimitDataHouse.status) {
            failHouse = true;
          }

          if (this.datastoreService.registration !== '') {
            const bookingLimitDataVehicle: any =
              await this.apiService.checkBookingLimit(
                this.datastoreService.parentDepartment,
                this.datastoreService.registration,
                slotDateTime,
                selectedService
              );
            if (!bookingLimitDataVehicle.status) {
              failVehicle = true;
            }
          }
        }
      } catch (err) {
        console.error('failed to check address limit');
        console.error(err);
      }

      if (failHouse || failVehicle) {
        if (failHouse) {
          this.alertService.error(
            this.translateService.instant(
              'FORM.HOUSEHOLD_WEEKLY_BOOKING_LIMIT_HOUSE',
              { limitMonth: limitMonth }
            )
          );
        }
        if (failVehicle) {
          this.alertService.error(
            this.translateService.instant(
              'FORM.HOUSEHOLD_WEEKLY_BOOKING_LIMIT_VEHICLE',
              { limitMonth: limitMonth }
            )
          );
        }

        this.scrollToTop();
        this.spinner.hide();
        return;
      }
    }

    this.datastoreService.config;
    let wasteLimitAnswers = [];
    let wasteLimit: any = {};
    if (this.bookingQuestionsForm.value[this.datastoreService.config.wasteLimits.haveWasteQuestion] === "Yes") {
      let parentDepartment = await this.departmentService.getParentDepartment();
      const slot: any = await this.availabilityService.getSelectedSlot();
      const slotDateTime = slot.datetime;
      wasteLimit = await this.apiService.getWasteLimit(parentDepartment.id, this.datastoreService.address1.toLowerCase().replace(/\s/g, "_"), moment(slotDateTime).format("DD-MM-YYYY"))
      if (wasteLimit.message !== undefined) {
        wasteLimit = {
          windowMaxDayLimit: {
            limit: this.datastoreService.config.wasteLimits.days,
            amount: 0,
            limitBreached: false
          },
          windowMaxWeightLimit: {
            limit: this.datastoreService.config.wasteLimits.weight,
            amount: 0,
            paid_qty: 0,
            limitBreached: false
          }
        }
      }

      if (wasteLimit.message === undefined) {
        const wasteQuestionId = this.datastoreService.config.wasteLimits.wasteQuestionId
        const answer = this.bookingQuestions.filter((x) => x.id.toString() === wasteQuestionId.toString())
        const answerId = answer[0].options.filter((x) => x.name === this.bookingQuestionsForm.value[wasteQuestionId])[0].id
        const myWeight = this.datastoreService.config.wasteLimits.wasteQuestionAnswerToWeight[answerId.toString()]

        wasteLimit.windowMaxDayLimit.amount++
        wasteLimit.windowMaxWeightLimit.amount += myWeight
        wasteLimit.windowMaxWeightLimit.amount -= wasteLimit.windowMaxWeightLimit.paid_qty

        if (wasteLimit.windowMaxDayLimit.amount > wasteLimit.windowMaxDayLimit.limit) {
          wasteLimit.windowMaxDayLimit.limitBreached = true;
          wasteLimitAnswers.push({
            id: this.datastoreService.config.wasteLimits.overBookingLimitQuestion,
            answer: true
          })
        }

        if (wasteLimit.windowMaxWeightLimit.amount > wasteLimit.windowMaxWeightLimit.limit) {
          wasteLimit.windowMaxWeightLimit.limitBreached = true;
          wasteLimitAnswers.push({
            id: this.datastoreService.config.wasteLimits.overWeightLimitQuestion,
            answer: true
          })
        }

      }
    }

    this.datastoreService.wasteLimitAnswers = wasteLimitAnswers;
    if (this.datastoreService.config.wasteLimits.wasteUnits) {
      this.wasteUnits = this.datastoreService.config.wasteLimits.wasteUnits;
    }
    if (wasteLimitAnswers.length > 0) {
      //
      this.wasteLimit = wasteLimit;
      this.showWasteWarning = true;
      this.scrollToTop();
      this.spinner.hide();
      return;
    } else {
      await this.completeDetails();
    }
  }

  async completeDetails() {
    const email = this.customerDetailsForm.controls['email_address'].value;

    // // Use email/phone to check if the user is banned
    // let res = await this.apiService.checkEmailNumber(email, null, this.selectedDepartment);

    // let checkAccount = new Promise((resolve, reject) => {
    //   if (res == undefined) {
    //     resolve("finished")
    //   }
    //   if (res["_source"] && res["_source"].questions) {
    //     if (res["_source"].questions.length > 0) {
    //       res["_source"].questions.forEach((question, index) => {
    //         if (question.id == 8 && question.answer == "1") {
    //           reject("banned")
    //           this.banned = true;
    //           return;
    //         }
    //         if (index === res["_source"].questions.length - 1) {
    //           resolve("finished");
    //         }
    //       });
    //     } else {
    //       resolve("finished");
    //     }
    //   } else {
    //     resolve("finished");
    //   }
    // });

    // checkAccount.then(async () => {

    this.datastoreService.bookingForm = this.bookingQuestionsForm;
    this.datastoreService.customerDetailsForm = this.customerDetailsForm;
    this.spinner.hide();

    var currentSlot = new Date(this.slot.datetime).toTimeString();

    let canContinue = true;
    this.unavailableTimes.forEach(bookedSlot => {
      if (currentSlot.includes(bookedSlot)) {
        // if the current slot matches an unavailable time, +1 to can continue (doing it like this so it doesn't break the loop)
        canContinue = (false)
      }
    });
    // If canContinue = (there is a match between current slot and unavailable time), then show error, otherwise continue
    if (!canContinue) {
      this.alertService.error(
        this.translateService.instant('COMMON.BACK_TO_BACK_BOOKINGS')
      );
      this.scrollToTop();
      this.spinner.hide();
      return;
    } else {
      console.log(this.datastoreService.registration);
      if (this.datastoreService.registration) {
        console.log('here');
        await this.checkVisitorAlertsTable(this.datastoreService.registration);
        console.log(this.datastoreService.banned);
        if (!this.datastoreService.banned) {
          this.router.navigate(['/summary']);
        } else {
          this.scrollToTop();
          this.alertService.warn(
            this.translateService.instant('COMMON.USER_BANNED')
          );
        }
      } else {
        this.router.navigate(['/summary']);
      }
    }
    // }).catch((e) => {
    //   console.log("ERROR", e);
    //   if (e == "banned") {
    //     this.alertService.warn(this.translateService.instant('COMMON.USER_BANNED'));
    //   } else {
    //     this.alertService.error(this.translateService.instant('COMMON.GENERAL_ERR'));
    //   }
    //   this.scrollToTop();
    //   this.spinner.hide();
    // });
  }

  parseWarning(warning) {
    warning = warning.replace("{{ visits count }}", this.wasteLimit.windowMaxDayLimit.amount)
    warning = warning.replace("{{ bags count }}", this.wasteLimit.windowMaxWeightLimit.amount)
    return warning
  }

  // Scroll to the top of the page
  scrollToTop() {
    window.scroll(0, 0);
  }

  // Number input text validation, keycode 8 is backspace
  keyPressNumberField(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  async checkIfDupeUser() {
    if (this.member) {
      return
    }
    const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    const res = this.customerDetailsForm.controls.email_address.value.match(emailRegex)
    console.log("res", res)
    let checkUser: any = false
    if (res && res.length > 0) {
      checkUser = await this.apiService.checkEmailAndName(
        this.customerDetailsForm.controls.email_address.value,
        this.departmentService.selectedDepartment.id
      );
      if (checkUser) {
        // continue if user not found or if jrni account is a contact
        if (checkUser.detail !== "Not Found" && (checkUser.client_type !== "Contact")) {
          // this.customerDetailsForm.controls["email"].setValue("")
          // this.customerDetailsForm.controls["email"].patchValue("")
          this.showDialog(checkUser);
          return { dupe: true, checkUser: checkUser }
        }
      }
    }
    return { dupe: false, checkUser: checkUser }
  }



  async showDialog(user) {
    console.log("showlg")
    const dialogRef = this.dialog.open(LoginPopupComponent, {
      width: '1000px',
      data: {
        header: this.translateService.instant('An account is already registered with your email address. Please login to continue.'),
        action: "login",
        user: user,
        // location,
        // member: this.member
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.spinner.hide()
    })
  }
}
